import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    backgroundColor: theme.palette.text.disabled,
    borderRadius: 0,
    [theme.breakpoints.down('xs')]: {
      height: 121,
      width: '96%',
      padding: '2%',
      borderRadius: 6,
    },
    [theme.breakpoints.up('sm')]: {
      width: 200,
      height: 350,
      padding: '10%',
      borderBottomLeftRadius: 12,
    },
  },
  storeBoxSubtitle: {
    fontSize: 11,
    fontWeight: 400,
    color: theme.palette.background.paper,
    fontFamily: 'InterSemiBold',
    textAlign: 'center',
    letterSpacing: '0.222px',
    [theme.breakpoints.down('xs')]: {
      fontSize: 11,
      fontWeight: 500,
      marginLeft: -80,
    },
  },
  storeBoxTitle: {
    marginTop: 10,
    fontSize: 20,
    lineHeight: '22px',
    fontWeight: 600,
    color: theme.palette.background.paper,
    fontFamily: 'InterSemiBold',
    textAlign: 'center',
    letterSpacing: '0.222px',
    [theme.breakpoints.down('xs')]: {
      marginTop: -1,
      fontSize: 16,
      fontWeight: 700,
    },
  },
  img: {
    [theme.breakpoints.down('xs')]: {
      width: 38,
      marginTop: 8,
    },
    [theme.breakpoints.up('sm')]: {
      width: 57,
      marginTop: 20,
      marginLeft: 60,
    },
  },
  storesButtonBox: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      marginTop: 50,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 30,
    },
  },
  storesImg: {
    height: '100%',
    width: 150,
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      width: 95,
    },
  },
}));

export const styles = {};
